import { render } from "./App.vue?vue&type=template&id=0d889bba"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0d889bba&lang=css"

import exportComponent from "/home/hyz-027/myprojects/vue/temple-management-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__